<template>
    <v-card style="background-color: transparent" elevation="0">
        <v-card-title
            :class="
                !$vuetify.display.mobile
                    ? 'title font-weight-regular justify-space-between'
                    : 'title font-weight-regular pa-1'
            "
        >
            <span>{{ wizardStepTitle }}</span>
        </v-card-title>
        <v-window v-model="wizardStep" touchless style="min-height: 27vh; min-width: 40vw">
            <v-window-item :value="-1">
                <v-card-text class="pa-0">
                    <v-list lines="two">
                        <v-list-item
                            class="mb-2 oss-list-item"
                            @click.stop="
                                wizardMode = 'Manual';
                                wizardStep = 0;
                            "
                        >
                            <template #prepend>
                                <v-icon color="primary">$fa-edit</v-icon>
                            </template>

                            <v-list-item-title>Créer</v-list-item-title>
                            <v-list-item-subtitle
                                >Créer un Z de caisse à la main</v-list-item-subtitle
                            >

                            <template #append class="d-flex align-center">
                                <v-btn-next />
                            </template>
                        </v-list-item>
                        <v-list-item
                            :class="
                                !$vuetify.display.mobile
                                    ? 'mb-2 oss-list-item'
                                    : 'mb-2 px-2 oss-list-item'
                            "
                            @click.stop="
                                wizardMode = 'UploadDocument';
                                wizardStep = 6;
                            "
                        >
                            <template #prepend>
                                <v-icon color="primary">$oss-upload</v-icon>
                            </template>
                            <v-list-item-title>Importer</v-list-item-title>
                            <v-list-item-subtitle>
                                Importer un fichier sur la plateforme : (Z de caisse ou facture
                                d'une plateforme de livraison)
                            </v-list-item-subtitle>
                            <template #append>
                                <v-btn-next />
                            </template>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-window-item>

            <v-window-item :value="0">
                <v-card-text class="pa-0">
                    <v-list subheader lines="two" v-model="period">
                        <!-- <v-list-group color="primary" v-model="period"> -->
                        <v-list-item
                            v-for="(item, i) in periods"
                            :key="i"
                            class="oss-list-item mb-2"
                            @click="period = item.key"
                            :data-cy="'zTillReceipt-period-' + item.key"
                            :class="{
                                active: period === item.key,
                                inactive: period !== item.key,
                            }"
                        >
                            <template #prepend>
                                <span class="white--text">{{ item.onegram }}</span>
                            </template>

                            <v-list-item-title>
                                {{ item.value }}
                            </v-list-item-title>

                            <template #append class="my-0">
                                <v-btn-icon
                                    v-if="period === item.key"
                                    icon="$mdi-radiobox-marked"
                                />
                                <v-btn-icon v-else icon="$mdi-radiobox-blank" />
                            </template>
                        </v-list-item>
                        <!-- </v-list-group> -->
                    </v-list>
                </v-card-text>
            </v-window-item>

            <v-window-item :value="1">
                <v-card-text class="pa-0">
                    <v-row>
                        <v-col cols="12" :key="period">
                            <template v-if="period === 'WE'">
                                <v-date-picker-wrapper
                                    v-model="week"
                                    range
                                    locale="fr-FR"
                                    full-width
                                    landscape
                                    :allowed-dates="allowedDates"
                                    class="elevation-0"
                                    color="secondary"
                                    first-day-of-week="1"
                                    scrollable
                                />
                            </template>
                            <v-date-picker-wrapper
                                v-else
                                v-model="date"
                                locale="fr-FR"
                                full-width
                                landscape
                                :allowed-dates="allowedDates"
                                :type="month ? 'month' : 'date'"
                                class="elevation-0"
                                color="secondary"
                                first-day-of-week="1"
                                scrollable
                            />
                        </v-col>
                    </v-row>
                    <v-alert type="warning" v-if="verifDate">{{ errorPeriodMessage }}</v-alert>
                </v-card-text>
            </v-window-item>

            <v-window-item :value="2">
                <v-card-text class="py-0">
                    <v-row>
                        <v-col cols="12">
                            <FreeTag
                                :companyTags="allCompanyTags"
                                :company="company"
                                document-type="ZTILL_RECEIPT"
                                @updateTags="updateTags($event)"
                            />
                        </v-col>
                    </v-row>
                    <v-list lines="two">
                        <v-list-item
                            v-for="(income, i) in incomes"
                            :key="i"
                            :class="
                                !$vuetify.display.mobile
                                    ? 'mb-2 py-2 oss-list-item'
                                    : 'mb-2 pa-2 oss-list-item'
                            "
                        >
                            <v-list-item-title>{{
                                getAccountableAccountDescription(income.accountableAccount)
                            }}</v-list-item-title>
                            <v-list-item-subtitle>{{ getSubTitle(income) }}</v-list-item-subtitle>
                            <template #append class="my-0">
                                <v-btn-trash @click="deleteCategory(income)" size="x-small" />
                            </template>
                        </v-list-item>
                    </v-list>
                    <v-col class="text-center">
                        <v-btn rounded @click="wizardStep = 3" elevation="0" size="small">
                            Ajouter une recette
                        </v-btn>
                    </v-col>
                </v-card-text>
            </v-window-item>

            <v-window-item :value="3">
                <v-card-text class="py-0">
                    <v-row>
                        <v-col cols="12">
                            <v-select-filled
                                v-model="income.accountableAccount"
                                :items="salesAccountableAccounts"
                                label="Type de recette"
                                item-value="name"
                                outlined
                                density="compact"
                                :item-title="(item) => item.description"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-select-filled
                                v-model="income.vatRate"
                                :items="vatRates"
                                label="Taux de TVA"
                                @update:model-value="VATRate(income, $event, false)"
                                outlined
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="12">
                            <oss-text-field-filled
                                v-model="income.grossAmount"
                                label="Montant TTC"
                                @update:model-value="TTCPrice(income, false)"
                                outlined
                                dense
                            />
                        </v-col>
                        <v-col cols="12">
                            <oss-text-field-filled
                                v-model="income.freeAmount"
                                label="Dont montant offert"
                                @update:model-value="onFreeAmountChanged()"
                                outlined
                                dense
                            />
                        </v-col>
                        <v-col cols="6" class="pb-2">
                            <span style="font-size: 12pt"
                                >HT :
                                {{ newCommonFormatCurrency(income.netAmount, undefined) }}</span
                            >
                        </v-col>
                        <v-col cols="6" class="pb-2">
                            <span style="font-size: 12pt"
                                >TVA :
                                {{ newCommonFormatCurrency(income.vatAmount, undefined) }}</span
                            >
                        </v-col>
                        <v-col
                            cols="12"
                            v-if="
                                currentUser.profile && currentUser.profile.configuration.tag.write
                            "
                        >
                            <FreeTag
                                v-bind:companyTags="allCompanyTags"
                                v-bind:document="income.document"
                                v-on:updateTags="onUpdateTag"
                                v-if="wizardStep === 3"
                            ></FreeTag>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-window-item>
            <v-window-item :value="4">
                <v-card-text class="py-0">
                    <!-- Commission -->
                    <v-row
                        class="d-flex align-center my-2 mx-2"
                        style="background-color: #fff; border-radius: 30px"
                        v-if="commission"
                    >
                        <v-col :cols="$vuetify.display.mobile ? '12' : ''">
                            <v-select-filled
                                outlined
                                :hide-details="true"
                                :items="vatRates"
                                item-value="value"
                                single-line
                                @update:model-value="VATRate(commission, $event)"
                                :model-value="
                                    commission.vatType
                                        ? commission.vatRate.toString() + commission.vatType
                                        : commission.vatRate
                                "
                                density="compact"
                            />
                        </v-col>
                        <v-col :cols="$vuetify.display.mobile ? '12' : ''">
                            <oss-text-field-filled
                                label="HT"
                                suffix="&#x20ac;"
                                hide-details
                                disabled
                                :model-value="commission.netAmount"
                            />
                        </v-col>
                        <v-col :cols="$vuetify.display.mobile ? '12' : ''">
                            <oss-text-field-filled
                                label="TVA"
                                suffix="&#x20ac;"
                                hide-details
                                disabled
                                :model-value="commission.vatAmount"
                            />
                        </v-col>
                        <v-col
                            :cols="$vuetify.display.mobile ? '12' : ''"
                            class="d-flex align-center justify-start"
                        >
                            <oss-text-field-filled
                                label="TTC"
                                v-model="commission.grossAmount"
                                @update:model-value="TTCPrice(commission)"
                                suffix="&#x20ac;"
                                hide-details
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-window-item>
            <v-window-item :value="5">
                <v-card-text class="py-0">
                    <v-row no-gutters v-for="(item, index) of transactions" :key="index">
                        <v-col class="pa-1 d-flex align-center justify-center">
                            <v-select-filled
                                v-model="item.name"
                                :items="transactionAccountableAccounts"
                                label="Type de transaction"
                                :item-title="getDescription"
                                item-value="name"
                                outlined
                                single-line
                                :hide-details="true"
                                density="compact"
                            />
                        </v-col>
                        <v-col class="pa-1 d-flex align-center justify-center">
                            <oss-text-field-filled
                                suffix="&#x20ac;"
                                dense
                                single-line
                                :hide-details="true"
                                v-model="item.amount"
                            />
                        </v-col>
                        <v-col cols="1" class="pa-1 d-flex align-center justify-center">
                            <v-btn-trash
                                v-if="transactions.length > 1"
                                @click="deleteTransaction(item)"
                                size="x-small"
                            >
                            </v-btn-trash>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" class="pa-1 d-flex align-center justify-end">
                            <v-btn-add-icon
                                class="mx-2 my-2"
                                size="x-small"
                                @click="addTransaction()"
                            >
                            </v-btn-add-icon>
                        </v-col>
                    </v-row>
                    <v-alert
                        class="align-self-end"
                        :type="alertType"
                        v-if="errorText"
                        :model-value="true"
                        variant="tonal"
                    >
                        {{ errorText }}
                    </v-alert>
                </v-card-text>
            </v-window-item>
            <v-window-item :value="6">
                <v-card-text class="py-0">
                    <UploadDocuments
                        :showFirstPrevious="false"
                        :companyId="companyId"
                        :documentType="'ZTILL_RECEIPT'"
                        :multiple="true"
                        :actions="actions"
                        @file="linkFile"
                    />
                </v-card-text>
            </v-window-item>
        </v-window>
    </v-card>
</template>

<script lang="ts">
import { Income, TicketZEditionBase } from "./TicketZEditionBase";
import UploadDocuments from "../document/UploadDocuments.vue";
import FreeTag from "../tag/FreeTag.vue";
import moment from "moment-timezone";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        UploadDocuments,
        FreeTag,
    },
})
export class TicketZEditionWizard extends TicketZEditionBase {
    @Prop({ default: true }) readonly showFirstPrevious: boolean;
    @Prop({ default: null }) actions: any;

    wizardStep_ = -1;

    wizardMode = "Manual";

    get wizardStep() {
        return this.wizardStep_;
    }

    set wizardStep(data) {
        this.wizardStep_ = data;
        if (this.actions && this.actions.action) {
            if (this.wizardStep === -1) {
                this.actions.action.display = false;
            } else if (this.wizardStep === 0) {
                this.actions.action.display = true;
                this.actions.action.disabled = () => {
                    return !this.period || this.period === "UNKNOWN";
                };
                this.actions.action.title = "Suivant";
                this.actions.action.function = this.nextStep;
            } else if (this.wizardStep === 2) {
                this.actions.action.display = true;
                this.actions.action.disabled = () => {
                    return !this.incomes.length;
                };
                this.actions.action.title = "Suivant";
                this.actions.action.function = this.nextStep;
            } else if (
                this.wizardStep === 1 ||
                ((this.wizardStep === 2 || this.wizardStep === 4) && this.withTransactions)
            ) {
                this.actions.action.display = true;
                this.actions.action.disabled = () => {
                    return !this.period || !this.date;
                };
                this.actions.action.title = "Suivant";
                this.actions.action.function = this.nextStep;
            } else if (this.wizardStep === 4 && !this.withTransactions) {
                this.actions.action.display = true;
                this.actions.action.disabled = () => {
                    return !this.status;
                };
                this.actions.action.title = "Créer";
                this.actions.action.function = this.valid;
            } else if (this.withTransactions ? this.wizardStep === 5 : this.wizardStep === 2) {
                this.actions.action.display = true;
                this.actions.action.disabled = () => {
                    return !this.status;
                };
                this.actions.action.title = "Créer";
                this.actions.action.function = this.valid;
            } else if (this.wizardStep === 3) {
                this.actions.action.display = true;
                this.actions.action.disabled = () => {
                    return !this.isIncomeValid(this.income);
                };
                this.actions.action.title = "Créer";
                this.actions.action.function = this.addIncome;
            } else {
                this.actions.action.display = false;
            }
        }
    }

    income: Income = {
        accountableAccount: "",
        vatRate: 20,
        vatAmount: 0.0,
        netAmount: 0.0,
        grossAmount: 0.0,
        freeAmount: 0.0,
        document: {
            type: "SALES_INVOICE",
            tags: [],
        },
        updateTags: null,
    };

    defaultIncome: Income = {
        accountableAccount: "",
        vatRate: 20,
        vatAmount: 0.0,
        netAmount: 0.0,
        grossAmount: 0.0,
        freeAmount: 0.0,
        document: {
            type: "SALES_INVOICE",
            tags: [],
        },
        updateTags: null,
    };

    beforeMount() {
        this.onBeforeMountCommon();
        if (this.actions && this.actions.action) {
            this.actions.action.display = () => {
                return this.wizardStep !== -1;
            };
            this.actions.action.disabled = this.isValid;
            this.actions.action.title = "Suivant";
            this.actions.action.function = this.nextStep;
        }
    }

    validDisabled() {
        switch (this.wizardStep) {
            case 0:
                return !this.period;
            case 3:
                return !this.incomes.length;
        }
        return false;
    }

    isValid() {
        switch (this.wizardStep) {
            case 0:
                return !!this.period;
            case 2:
                return !!this.incomes.length;
        }
        return true;
    }

    initializeSalesAccountableAccount() {
        if (this.salesAccountableAccounts.length) {
            this.income.accountableAccount = this.salesAccountableAccounts[0].name;
            this.defaultIncome.accountableAccount = this.salesAccountableAccounts[0].name;
        } else {
            this.income.accountableAccount = "";
            this.defaultIncome.accountableAccount = "";
        }
    }

    get wizardStepTitle() {
        switch (this.wizardStep) {
            case -1:
                return "Faites votre choix";
            case 0:
                return "Choisissez la période";
            case 1:
                return "Choisissez la date";
            case 2:
                return "Qu'avez vous encaissé comme recettes pour cette période ?";
            case 3:
                return "Ajouter une recette";
            case 4:
                return "Commission | Frais";
            case 5:
                return "Répartition des encaissements";
            case 6:
                return "Importer un fichier";
        }
        return "Title" + this.wizardStep;
    }

    disabledNextStep() {
        if (this.wizardStep >= 3) return true;
        return false;
    }

    nextStep() {
        if (this.wizardStep === 1) {
            if (this.wizardMode === "Manual") {
                this.wizardStep = 2;
            } else {
                this.wizardStep = 6;
            }
            this.date = moment().startOf("day").format();
            this.wizardStep++;
        } else if (this.wizardStep === 2) {
            this.wizardStep = 4;
        } else {
            this.wizardStep++;
        }
    }

    previousStep() {
        if (this.wizardStep < -1) return;
        if (this.wizardStep === -1) {
            this.$emit("back");
            return;
        }
        if (this.wizardStep === 4) {
            this.wizardStep = 2;
        } else if (this.wizardStep === 6) {
            this.wizardStep = -1;
        } else {
            this.wizardStep--;
        }
    }

    getSubTitle(income) {
        let title = this.newCommonFormatCurrency(income.grossAmount, undefined);
        title += " (" + income.vatRate + "%)";
        return title;
    }

    addIncome() {
        this.incomes.push(this.income);
        this.verifValidation();
        this.income = { ...this.defaultIncome };
        this.wizardStep = 2;
    }

    getPeriodClass() {
        const periodClass = "oss-list-item mb-2";
        return periodClass;
    }

    onUpdateTag(data) {
        this.income.updateTags = data;
    }

    async linkFile(data) {
        this.file = data.file;
        this.tags = data.tags;
        this.status = true;
        await this.valid();
    }

    updateTags(data) {
        this.tags = data;
    }
}

export default toNative(TicketZEditionWizard);
</script>
<style lang="scss" scoped>
.v-list-item {
    min-height: auto !important;

    .white--text {
        background-color: black;
        color: white;
        padding: 5px;
        margin-right: 20px;
        border-radius: 25px;
        font-size: 14px;
        height: 35px;
        width: 35px;
        padding-top: 8px;
        text-align: center;
    }

    &::before {
        opacity: 0;
        background-color: #262626;
        bottom: 0;
        content: "";
        left: 0;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    }

    &.active::before {
        opacity: 0.12;
    }
}
</style>
